export default __webpack_public_path__ + "static/media/check_circle.4a3bff98.svg";